import { IDictionaryItem, IPersonalDiagnostic, IPersonalDiagnosticLearningGroup } from 'api/types';
import { DIAGNOSTIC_SUBJECT_ALL_CODE, DIAGNOSTIC_SUBJECT_ALL_VALUE } from 'const';

export const getFilteredDiagnostics = (diagnostics: IPersonalDiagnostic[], filterSubject: string | null) => {
  const filteredDiagnostics =
    filterSubject === null ? diagnostics : diagnostics.filter((diagnostic) => diagnostic.subject === filterSubject);

  const sortedDiagnostics = [...filteredDiagnostics].sort(
    (a, b) => new Date(b.eventDate).getFullYear() - new Date(a.eventDate).getFullYear(),
  );

  return sortedDiagnostics;
};

export const getLearningYearOptions = (diagnosticGroups: IPersonalDiagnosticLearningGroup[]) => {
  const learningYearsOptions = [...diagnosticGroups]
    .sort((a, b) => {
      return Number(b.learningYear.split('-')[0]) - Number(a.learningYear.split('-')[0]);
    })
    .map((group, index): IDictionaryItem => {
      return {
        code: index + 1,
        value: group.learningYear,
      };
    });
  return learningYearsOptions;
};

export const getSubjectOptions = (diagnostics: IPersonalDiagnostic[]) => {
  const allSubjects = diagnostics.map((diagnostic) => diagnostic.subject);
  const uniqueSubjects = Array.from(new Set(allSubjects));
  const subjectOptions = uniqueSubjects.map((subject, index): IDictionaryItem => {
    return {
      code: index + 1,
      value: subject,
    };
  });
  subjectOptions.unshift({
    code: DIAGNOSTIC_SUBJECT_ALL_CODE,
    value: DIAGNOSTIC_SUBJECT_ALL_VALUE,
  });
  return subjectOptions;
};
